export const ForkAndKnifeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M3.3335 0.833252V4.66658C3.3335 5.77115 4.22893 6.66658 5.3335 6.66658H6.3335C7.43807 6.66658 8.3335 5.77115 8.3335 4.66658V0.833252" />
      <path d="M5.8335 0.833252V9.99992" />
      <path d="M16.6665 0.833252V12.4999" />
      <path d="M16.6665 0.833252V0.833252C13.558 2.75753 11.6665 6.15314 11.6665 9.80901V11.6666H16.6665" />
      <rect x="4.1665" y="10" width="3.33333" height="9.16667" rx="1.66667" />
      <path d="M13.3335 11.6667H16.6668V17.5001C16.6668 18.4206 15.9206 19.1667 15.0002 19.1667V19.1667C14.0797 19.1667 13.3335 18.4206 13.3335 17.5001V11.6667Z" />
    </svg>
  );
};
